var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    enableBackground: "new 0 0 58 58",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    transform: "matrix(0.035, 0.999, -0.999, 0.035, 131.94, -13.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-point-to-right",
    transform: "translate(12.838 111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    fill: "#FFFFFF",
    d: "M23.89,9.163L-0.355-15.086c-1.651-1.432-1.828-3.932-0.396-5.584 c1.432-1.651,3.932-1.829,5.583-0.396c0.141,0.122,0.276,0.255,0.398,0.396L26.682,0.787l21.453-21.455 c1.646-1.438,4.146-1.269,5.586,0.377c1.303,1.49,1.303,3.716,0,5.207L29.474,9.165c-1.545,1.536-4.04,1.536-5.584,0L23.89,9.163z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.3bce406cf0028c8c2531d31d39bf0f03.svg";
export { ForwardRef as ReactComponent };